module.exports = __webpack_public_path__ + "./images/2c4e2fb61f10f6dcf3347199f389d04d.svg";